
import React, { useEffect, useState } from 'react'
import { Container } from 'react-bootstrap';
import { connect } from 'react-redux'
import { toast } from 'react-toastify';
import { setGlobalLoading } from 'redux/actions/actionCommon'
import { addPaymentIntegration, getPaymnetIntegartion } from 'utlis/Apis/Payment_API';
import { UNKNOWN_ERROR_OCCURED } from 'utlis/AppMessages/AppMessages';
import { ERROR_WHILE_FETCHING_PAYMENTINTEGRATION } from 'utlis/AppMessages/AppMessages';
import useQueryHook from 'utlis/CustomHooks/useQueryHook';
import { getFromLocalStorage, saveToLocalStorage } from 'utlis/helpers/Common/CommonHelperFunctions';

function StripeConnect(props) {
    let query = useQueryHook();
    const [integration, setIntegration] = useState({})
    const [error, setError] = useState(null)
    const [connecting, setConnecting] = useState(true)

    useEffect(() => {
        const user = props.currentUser
        setConnecting(true)
        getPaymnetIntegartion(user.userToken, user.userId).then(res => {
            const resData = res.data
            window.scrollTo(0, 0)
            if (resData && resData.success) {
                const intergration_ = JSON.parse(resData.data || "{}") || {}
                const code = query.get("code")
                if (!code) {
                    setConnecting(false)
                    setError("Something went wrong.")
                } else {
                    intergration_.stripe = {
                        code,
                        enabled: true
                    }
                    addPaymentIntegration(props.currentUser.userToken,
                        { account_id: user.userId, data: JSON.stringify(intergration_) }).then(res => {
                            onSuccess(res.data)
                        }).catch(e => {
                            console.log("error", e)
                        })

                }

            }

            if (resData && resData.error) {
                toast.dismiss();
                toast.error(ERROR_WHILE_FETCHING_PAYMENTINTEGRATION, {
                    autoClose: 3000
                })
            }
        }).catch(err => {
            toast.dismiss();
            toast.error(UNKNOWN_ERROR_OCCURED, {
                autoClose: 2500,
                onClose: () => {
                }
            })
        })

    }, [props.currentUser.token, props])



    const onSuccess = (res) => {
        setConnecting(false)
        if (res.success && res.data) {
            // saveToLocalStorage("qb_token", res.data.refresh_token);
            // saveToLocalStorage("qb_ref_token", res.data.access_token);
            // saveToLocalStorage("qb_realm_id", res.data.realm_id);
            props.history.push('/settings/payment')
        } else {
            setError(res.message || "Something went wrong.")
        }
    }
    return (
        <section id="app-integration-details" className="st-def-mar-TB page-eorc-wrapper">
            <Container fluid className="st-container">
                {connecting ? "connecting.." : (!error ?
                    <div>"Connected"<br />
                        {/* <Link to="/settings/integration/quickbooks/settings" className="text-decoration-none st-text-primary d-inline-flex align-items-center cursor-pointer st-fs-15">
                            <FeatherIcon
                                icon="settings"
                                size="14"
                                className="icon me-1" />
                            <span>Settings</span>
                        </Link> */}

                    </div>
                    : error)}
            </Container >
        </section >
    )
}

const getDataFromStore = state => {
    return {
        currentUser: state.auth.currentUser
    };
}

const dispatchActionsToProps = dispatch => {
    return {
        setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
    }
}

export default connect(getDataFromStore, dispatchActionsToProps)(StripeConnect)